import React, { useState } from 'react';
import { faqs } from '../mockData/mock';
import { HelpCircle, ChevronDown } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const FAQ = () => {
  const [expandedFaqs, setExpandedFaqs] = useState([]);

  const toggleFaq = (id) => {
    setExpandedFaqs(prev =>
      prev.includes(id)
        ? prev.filter(faqId => faqId !== id)
        : [...prev, id]
    );
  };

  return (
    <div className="min-h-screen bg-[#f7f5f2]">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-white to-[#f7f5f2] py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center justify-center space-x-2 bg-[#a8b5a0]/10 px-4 py-2 rounded-full mb-6">
            <HelpCircle className="h-5 w-5 text-[#a8b5a0]" />
            <span className="text-sm font-medium text-[#736c64]">Quick Answers</span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#1e1919] mb-6">
            Frequently Asked Questions
          </h1>
          <p className="text-xl text-[#736c64] max-w-2xl mx-auto">
            Quick answers to the most common questions from sourdough beginners.
          </p>
        </div>
      </section>

      {/* FAQ List */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-4">
            {faqs.map((faq) => (
              <Card key={faq.id} className="overflow-hidden hover:shadow-md transition-shadow">
                <button
                  onClick={() => toggleFaq(faq.id)}
                  className="w-full text-left"
                >
                  <CardContent className="p-6">
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex-grow">
                        <div className="flex items-start gap-3">
                          <HelpCircle className="h-5 w-5 text-[#a8b5a0] flex-shrink-0 mt-1" />
                          <h3 className="text-lg font-semibold text-[#1e1919] pr-4">
                            {faq.question}
                          </h3>
                        </div>
                      </div>
                      <ChevronDown
                        className={`h-5 w-5 text-[#736c64] flex-shrink-0 transition-transform ${
                          expandedFaqs.includes(faq.id) ? 'rotate-180' : ''
                        }`}
                      />
                    </div>

                    {expandedFaqs.includes(faq.id) && (
                      <div className="mt-4 pl-8 animate-in fade-in slide-in-from-top duration-200">
                        <p className="text-[#736c64] leading-relaxed">
                          {faq.answer}
                        </p>
                      </div>
                    )}
                  </CardContent>
                </button>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Still Have Questions Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-[#1e1919] mb-4">
              Still Have Questions?
            </h2>
            <p className="text-lg text-[#736c64] mb-8">
              We're here to help! Check out our troubleshooting guide or contact us directly.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/troubleshooting"
                className="inline-flex items-center justify-center px-6 py-3 bg-[#a8b5a0] hover:bg-[#8fa087] text-white rounded-lg font-medium transition-colors"
              >
                Troubleshooting Guide
              </a>
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#e8e6e1] hover:bg-white text-[#736c64] rounded-lg font-medium transition-colors"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
